import React from 'react'
import { ParallaxProvider } from "react-scroll-parallax";
import { motion } from "framer-motion";
import { MyChatbot } from './ChatBot';
import styled from 'styled-components';
import MyProjects from '../projects/MyProjects';
import { Parallax } from "react-scroll-parallax";
import BrandExample from '../navBar/Brand';
import '../projects/projects.css'


function ProjectsPage() {
  return (
    <ParallaxProvider>
      <motion.div className="hero">
        <BrandExample />
        <Title>Projects</Title>
        <Wrapper className='wrapper'>
          <MyProjects />
          <MyChatbot />
        </Wrapper>
      </motion.div>
    </ParallaxProvider>
  );
}

export default ProjectsPage

const Wrapper = styled.div`
    display: flex;
    width: 90%;
    margin: auto;
    justify-content: space-around;
    align-items: flex-start;
    // border: solid yellow 3px;
`

const Title = styled.h2`
    color: white;
    text-align: center;
    margin: 2rem;
    font-size: 3.5rem;
    margin-top: 0;
`